import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-split-pane-frame',
  templateUrl: './split-pane-frame.component.html',
  styleUrls: ['./split-pane-frame.component.css']
})
export class SplitPaneFrameComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
